// ── NAV SCROLL ──
  const navbar = document.getElementById('navbar');
  window.addEventListener('scroll', () => {
    navbar.classList.toggle('scrolled', window.scrollY > 50);
  }, { passive: true });

  // ── HAMBURGER ──
  const hamburger = document.getElementById('hamburger');
  const mobileMenu = document.getElementById('mobileMenu');

  function toggleMenu(open) {
    hamburger.classList.toggle('open', open);
    mobileMenu.classList.toggle('open', open);
    mobileMenu.style.display = open ? 'flex' : 'none';
    mobileMenu.setAttribute('aria-hidden', String(!open));
    hamburger.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = '';
  }

  hamburger.addEventListener('click', () => {
    const isOpen = hamburger.classList.contains('open');
    toggleMenu(!isOpen);
    if (!isOpen) setTimeout(() => mobileMenu.style.display = 'flex', 10);
  });

  document.querySelectorAll('.mobile-link').forEach(link => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');
      if (href && href !== '#') {
        toggleMenu(false);
        setTimeout(() => {
          window.location.href = href;
        }, 100);
      } else {
        toggleMenu(false);
      }
    });
  });

  // ── SCROLL REVEAL ──
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  document.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach(el => {
    revealObserver.observe(el);
  });

  // ── NEWSLETTER ──
  function handleSignup(e) {
    e.preventDefault();
    const msg = document.getElementById('signup-msg');
    msg.style.display = 'block';
    e.target.reset();
    setTimeout(() => { msg.style.display = 'none'; }, 5000);
  }

  // ── SMOOTH CLOSE MOBILE ON EXTERNAL LINK ──
  document.querySelectorAll('a[href^="http"]').forEach(link => {
    link.addEventListener('click', () => toggleMenu(false));
  });

  // ── PRODUCT CARD FRONT/BACK FLIP ──
  document.querySelectorAll('.flip-toggle').forEach(btn => {
    const toggleFlip = (e) => {
      e.preventDefault();
      e.stopPropagation();
      const card = btn.closest('.product-card');
      if (card) card.classList.toggle('flipped');
    };
    btn.addEventListener('click', toggleFlip);
    btn.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') toggleFlip(e);
    });
  });
